import React from 'react';
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaTiktok, FaYoutube } from 'react-icons/fa';
import { useSiteContent } from '../context/SiteContentContext';

// VEC's social pages, as set at /admin-portal/general (P11 task #131). Used by
// the footer, the header and the contact pop-up so every place shows the same
// links. An icon only renders when its URL is set — never a placeholder.
export const SOCIAL_PLATFORMS = [
  { key: 'social_tiktok',    label: 'TikTok',    Icon: FaTiktok },
  { key: 'social_instagram', label: 'Instagram', Icon: FaInstagram },
  { key: 'social_facebook',  label: 'Facebook',  Icon: FaFacebookF },
  { key: 'social_linkedin',  label: 'LinkedIn',  Icon: FaLinkedinIn },
  { key: 'social_youtube',   label: 'YouTube',   Icon: FaYoutube },
];

export function useSocialLinks() {
  const { globalContent } = useSiteContent();
  // .trim() guards against a whitespace-only CMS value, which would otherwise
  // render an empty, focusable link.
  return SOCIAL_PLATFORMS
    .map(({ key, label, Icon }) => ({ label, Icon, url: (globalContent[key] || '').trim() }))
    .filter((s) => s.url);
}

const SocialLinks = ({ listClassName, linkClassName, size = 18, label = 'VisionExploit on social media' }) => {
  const links = useSocialLinks();
  if (links.length === 0) return null;
  return (
    <ul className={listClassName} aria-label={label}>
      {links.map(({ label: name, Icon, url }) => (
        <li key={name}>
          <a href={url} target="_blank" rel="noopener noreferrer" className={linkClassName} aria-label={name} title={name}>
            <Icon size={size} aria-hidden="true" />
          </a>
        </li>
      ))}
    </ul>
  );
};

export default SocialLinks;
